import { useState, useCallback } from 'react';
import {
  getServiceRoles, getServiceAnalisisRoles, putServiceRole, postServiceRole,
} from '../services/roles';

const useRoles = () => {
  const [state, setState] = useState({ loading: false, error: null, roles: [] });

  const getRoles = useCallback(async () => {
    setState({ loading: true, error: null, roles: [] });
    try {
      const rolesService = await getServiceRoles();
      const roles = rolesService.map(({ permissions, ...rest }) => ({ ...rest }));
      setState({ loading: false, error: null, roles });
      return roles;
    } catch (e) {
      setState({ loading: false, error: e, roles: [] });
      return [];
    }
  });

  const getRol = useCallback(async (data) => {
    setState({ loading: true, error: null, roles: [] });
    try {
      const roleService = await getServiceRoles(`/${data}`);
      setState({ loading: false, error: null, roleService });
      return roleService;
    } catch (e) {
      setState({ loading: false, error: e, roles: [] });
      return [];
    }
  });

  const getAnalisisRol = useCallback(async (data) => {
    setState({ loading: true, error: null, roles: [] });
    try {
      const roleService = await getServiceAnalisisRoles(data);
      setState({ loading: false, error: null, roleService });
      return roleService;
    } catch (e) {
      setState({ loading: false, error: e, roles: [] });
      return [];
    }
  });

  const editRole = useCallback(async (data) => {
    setState({ loading: true, error: null });
    try {
      await putServiceRole(data);
      setState({ loading: false, error: null });
      return true;
    } catch (e) {
      setState({ loading: false, error: e });
      return false;
    }
  });

  const createRole = useCallback(async (data) => {
    setState({ loading: true, error: null });
    try {
      await postServiceRole(data);
      setState({ loading: false, error: null });
      return true;
    } catch (e) {
      setState({ loading: false, error: e });
      return false;
    }
  });

  return {
    isRolesLoading: state.loading,
    rolesError: state.error,
    getRoles,
    getRol,
    getAnalisisRol,
    editRole,
    createRole,
  };
};

export default useRoles;
